<template>
    <div class="basicData" v-wechat-title="$t('添加/编辑区域信息')">
        <Title :title="$t('添加/编辑区域信息')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('服务区域') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.areaId" clearable :placeholder="$t('请选择')" @change="changeSelect">
                            <el-option
                                    v-for="item in optionsOne"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('应用中心') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="centerName" maxlength="15" disabled></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('区域负责人') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="managerName" maxlength="15" disabled></el-input>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('国家') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.countryId" :placeholder="$t('请选择')" @change="divisionList(2, $event)">
                            <el-option
                                    v-for="item in listFour"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('省份') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.provinceId" clearable filterable :placeholder="$t('请选择')" @change="divisionList(3, $event)">
                            <el-option
                                    v-for="item in listFive"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('城市') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.prefectureId" clearable filterable :placeholder="$t('请选择')" @change="divisionList(4, $event)">
                            <el-option
                                    v-for="item in listSix"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('区县') }}</span></div>
                    <div class="input_box">
                        <el-select  v-model.trim="parameters.countyId" clearable filterable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in listSeven"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span></span></div>
                    <div class="input_box">

                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span></span></div>
                    <div class="input_box">

                    </div>
                </div>
            </div>
        </div>
        <div class="edit_btn_box">
            <button type="button" class="back_btn" @click="$router.go(-1)">{{ $t('返回') }}</button>
            <button type="button" class="save_btn" @click="save" v-permissions="26010403" v-noClick>{{ $t('保存') }}</button>
        </div>
        <Dialog v-if="isShow" :message="message" @cancel="isShow = false" @sure="$router.go(-1)"/>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                isShow: false,
                message: '',
                listFour: [],
                listFive: [],
                listSix: [],
                listSeven: [],
                optionsOne: [],
                parameters: {
                    id: '',
                    areaId: '',
                    countryId: 0,
                    provinceId: '',
                    prefectureId: '',
                    countyId: ''
                },
                centerName: '',
                managerName: ''
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                this.getOrganizationListAll()
                if (!this.$route.query.id) {
                    this.divisionList(1, -1)
                    this.divisionList(2, 0)
                }
                if (this.$route.query.id) this.read()
            },
            changeSelect (value) {
                if (!value) {
                    this.centerName = this.managerName = ''
                    return false
                }
                this.$store.dispatch('a:maintainAreaInfo/infoByArea', {areaId: value}).then(
                    res => {
                        this.centerName = res.center
                        this.managerName = res.areaManager
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            save () {
                if (!this.parameters.areaId || this.parameters.countryId==='' || !this.parameters.provinceId) {
                    this.$message.info(this.$t('请填写必填信息'))
                    return false
                }
                if (this.$route.query.id) {
                    if (!this.parameters.prefectureId) {
                        this.$message.info(this.$t('请选择') + this.$t('城市'))
                        return false
                    }
                    if (!this.parameters.countyId) {
                        this.$message.info(this.$t('请选择') + this.$t('区县'))
                        return false
                    }
                }
                this.$store.dispatch('a:maintainAreaInfo/save', this.parameters).then(
                    res => {
                        if (res.message !== '') {
                            this.message = res.message
                            this.isShow = true
                        } else {
                            this.$message.success(this.$t('保存成功'));
                            this.$router.go(-1)
                        }
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            read () {
                this.$store.dispatch('a:maintainAreaInfo/read', {id: this.$route.query.id}).then(
                    res => {
                        this.divisionList(1, -1)
                        this.divisionList(2, res.countryId)
                        this.divisionList(3, res.provinceId)
                        this.divisionList(4, res.prefectureId)
                        this.parameters.countryId = 0
                        this.parameters = {
                            ...res,
                            id: this.$route.query.id
                        }
                        this.centerName = res.centerName
                        this.managerName = res.managerName
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getOrganizationListAll () {
                this.$store.dispatch('a:common/getOrganizationListAll', {
                    level: 3,
                    parentId: ''
                }).then(
                    res => {
                        this.optionsOne = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            divisionList (level, id) {
                if (level === 3) {
                    this.parameters.prefectureId = this.parameters.countyId = ''
                    this.listSix = this.listSeven = []
                    if (id === '') return false
                } else if (level === 4) {
                    this.parameters.countyId = ''
                    this.listSeven = []
                    if (id === '') return false
                }
                this.$store.dispatch('a:maintainAreaInfo/divisionList', {
                    parentId: id
                }).then(
                    res => {
                        switch (level) {
                            case 1:
                                this.listFour = res
                                break;
                            case 2:
                                this.listFive = res
                                break;
                            case 3:
                                this.listSix = res
                                break;
                            case 4:
                                this.listSeven = res
                                break;
                        }
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
